import { authQueries, scopedQueries, UseQueryOptionsObject } from 'src/api/queries/queries';
import { defaultOptions } from 'src/api/queries/queries.utils';
import { PaginatedResponse } from 'src/api/Client';
import { brandClient, BrandsTableResponse } from 'src/lib/services/api/brand-api';
import { useMakeQuery } from 'src/api/queries/useMakeQuery';
import { ApiQueryObject } from 'src/lib/services/api-query-params';
import { reactQueryClient } from 'src/providers/ReactQueryClientProvider';

const baseBrandsQueryKey = [authQueries.brands, scopedQueries.table];

const invalidateBrandsQuery = () => {
  reactQueryClient.invalidateQueries(baseBrandsQueryKey);
};

const useBrandsQuery = (
  params: ApiQueryObject = {},
  options?: UseQueryOptionsObject<PaginatedResponse<BrandsTableResponse>>,
) => {
  return useMakeQuery<PaginatedResponse<BrandsTableResponse>>(
    [...baseBrandsQueryKey, params],
    () => brandClient.index({ params }),
    {
      staleTime: 60 * 1000,
      ...defaultOptions({
        auth: true,
        ...(options ?? {}),
      }),
    },
  );
};

export { baseBrandsQueryKey, useBrandsQuery, invalidateBrandsQuery };
